let lastId = 0;

function uniqueID(prefix= 'id') {
  lastId++;
  return `${prefix}-${lastId}`;
}

export default uniqueID;
